import type React from 'react';

import { ThemeProvider } from '@mui/material/styles';
import { Helmet } from 'react-helmet';
import { useIntl } from 'react-intl';

import Root from './components/b2c/Root';
import { mUiTheme } from './materialUiTheme';
import Routes from './routesB2c';

const AppB2c: React.FunctionComponent = () => {
  const intl = useIntl();
  const seoTitle = intl.formatMessage({ id: 'app.seo-title' });
  const seoDescription = intl.formatMessage({ id: 'app.seo-description' });
  const logoPath = `${process.env.PUBLIC_URL}/assets/logos/bam-togo-maskable-512.png`;

  return (
    <Root>
      <Helmet>
        {/* <!-- HTML Meta Tags --> */}
        <title>{seoTitle}</title>
        <meta name='description' content={seoDescription} />

        {/* <!-- Google / SERP Tags --> */}
        <meta itemProp='name' content={seoTitle} />
        <meta itemProp='description' content={seoDescription} />
        <meta itemProp='image' content={logoPath} />

        {/* <!-- Facebook / OpenGraph Meta Tags --> */}
        <meta property='og:url' content={process.env.PUBLIC_URL} />
        <meta property='og:type' content='website' />
        <meta property='og:title' content={seoTitle} />
        <meta property='og:description' content={seoDescription} />
        <meta property='og:image' content={logoPath} />

        {/* <!-- Twitter Meta Tags --> */}
        <meta name='twitter:card' content='summary_large_image' />
        <meta name='twitter:title' content={seoTitle} />
        <meta name='twitter:description' content={seoDescription} />
        <meta name='twitter:image' content={logoPath} />
      </Helmet>
      <ThemeProvider theme={mUiTheme}>
        <Routes />
      </ThemeProvider>
    </Root>
  );
};

export default AppB2c;
